import { TimeFormatOptions } from '@bcf-v2-ui-shared/misc/date-utils/get-simplified-format-relative-locale';

export const timeFormatOptions: TimeFormatOptions = {
  suffixTimeFormat: ', hh:mm a'
};
